import { render, staticRenderFns } from "./acquired.vue?vue&type=template&id=851698b4&lang=pug&"
import script from "./acquired.vue?vue&type=script&lang=js&"
export * from "./acquired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports